module.exports = __webpack_public_path__ + "static/media/help.0142c357.svg";